export default "__VITE_ASSET__DRouHibw__"